<template>
  <Dialog :open="value" @close="$emit('input', false)">
    <template v-slot:title>
      <Label text="スカウト送付者の追加" size="h5" bold />
    </template>

    <FlexColumn>
      <FlexRow justify="end">
        <RequiredItemText/>
      </FlexRow>
      <RequestorForm v-model="requestor" ref="requestorForm" />
    </FlexColumn>

    <template v-slot:actions>
      <FlexRow align="center" justify="center" full-width>
        <TextButton @click="$emit('input', false)">キャンセル</TextButton>
        <Button outlined @click="handleSubmit">追加</Button>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "../atoms/Dialog";
import Label from "../atoms/Label";
import FlexRow from "../atoms/FlexRow";
import TextButton from "../atoms/TextButton";
import Button from "../atoms/Button";
import FlexColumn from "../atoms/FlexColumn";
import RequiredItemText from "../atoms/RequiredItemText";
import RequestorForm from "./RequestorForm";
import ApiMixin from "../../ApiMixin";
export default {
  name: "RequestorCreateDialog",
  mixins: [ApiMixin],
  components: {
    RequestorForm,
    RequiredItemText,
    FlexColumn, Button, TextButton, FlexRow, Label, Dialog},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: String
    }
  },
  data() {
    return {
      requestor: {
        firstName: "",
        lastName: "",
        post: "",
        icon: undefined
      },
      iconData: undefined
    }
  },
  computed: {
    iconUrl() {
      return this.iconData
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.$refs.requestorForm.validate()) return

      const requestor = await this.saveRequestor(
          this.companyId, undefined,
          this.requestor.firstName, this.requestor.lastName, this.requestor.post)

      if (this.requestor.icon) {
        await this.uploadRequestorImage(this.companyId, requestor.id, this.requestor.icon)
      }

      this.$emit('input', false)
    },
  }
}
</script>

<style scoped>

</style>